import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { ButtonLinkWithIcon, Text } from '@blueprint/ui';
import { Link } from '@blueprint/link';
import { PrimaryList } from '../PrimaryNav/PrimaryNav.styles';
import smallZ from '../../zLogo';

const ProfileMenuWrapper = styled('div')(
    (props) => css`
        position: relative;
        padding-top: 1rem;

        ${props.theme.mediaQueries.large} {
            padding-top: 0;
        }

        @media (min-width: 1400px) {
            z-index: 2;
        }
    `
);

const ProfileWrapper = styled(PrimaryList)(
    (props) => css`
        display: flex;
        flex-flow: column nowrap;

        ${props.theme.mediaQueries.large} {
            flex-flow: row wrap;
            padding: 0;
            align-items: center;
        }

        > li {
            position: relative;

            header:not([data-is-logged-in]) &[data-is-logged-in='true'] {
                display: none;
            }

            [data-is-logged-in] &[data-is-logged-in='false'] {
                display: none;
            }

            ${props.theme.mediaQueries.large} {
                margin-bottom: 0;
            }

            &:last-child {
                ${ButtonLinkWithIcon}:after {
                    margin-bottom: -2;
                }
            }
        }

        ${ButtonLinkWithIcon} {
            font-size: 14px;
            line-height: 20px;
            padding: 14px 24px;
            text-decoration: none;
            text-align: left;
            border-radius: ${props.theme.borderRadius['4px']};
            display: flex;
            justify-content: start;
            align-items: center;

            &:focus,
            &:hover {
                text-decoration: none;
                transform: translateY(0);
            }

            :focus {
                box-shadow: inset ${props.theme.focusRing};
            }

            ${props.theme.mediaQueries.large} {
                padding: 14px ${props.theme.spacing['16px']};

                &:focus,
                &:hover {
                    &:after {
                        opacity: 1;
                        height: 2px;
                    }
                }
            }

            &:after {
                content: '';
                position: absolute;
                height: 1px;
                background-color: ${props.theme.colors['primary-brand']};
                opacity: 0;
                left: ${props.theme.spacing['16px']};
                bottom: ${props.theme.spacing['16px']};
                right: ${props.theme.spacing['16px']};
                margin-bottom: -2px;
            }

            div {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin: 0;

                svg {
                    margin-bottom: 3px;
                    margin-right: 0;
                }
                ${Text} {
                    font-size: ${props.theme.fontSizes['1']};
                }
            }
        }
    `
);

const IconWrapper = styled('div')(
    (props) => css`
        padding: 0 ${props.theme.spacing['16px']};
        padding-bottom: ${props.theme.spacing['24px']};

        ${props.theme.mediaQueries.large} {
            display: none;
        }

        ${Link} {
            display: inline-block;
            margin-right: ${props.theme.spacing['24px']};

            > * {
                pointer-events: none;
            }

            &:last-of-type {
                margin-right: 0;
            }

            header:not([data-is-logged-in]) &[data-is-logged-in='true'] {
                display: none;
            }

            [data-is-logged-in] &[data-is-logged-in='false'] {
                display: none;
            }
        }
    `
);

const AccountMenuWrapper = styled('div')(
    (props) => css`
        display: none;
        ${props.theme.mediaQueries.large} {
            position: absolute;
            right: ${props.theme.spacing['16px']};
            display: block;
            height: 0;
            visibility: hidden;
            z-index: 2;

            > * {
                display: none;
            }

            [data-is-logged-in] & *[data-is-logged-in='false'] {
                display: none;
            }

            header:not([data-is-logged-in]) & *[data-is-logged-in='true'] {
                display: none;
            }

            [data-is-logged-in] li:last-of-type:focus-within &,
            [data-is-logged-in] li:last-of-type:hover &,
            [data-is-logged-in] li:last-of-type:focus & {
                height: auto;
                visibility: visible;
                overflow: initial;

                > * {
                    display: block;
                }
            }
        }
    `
);

const SignedInLink = styled('li')(
    (props) => css`
        display: none;

        ${props.theme.mediaQueries.large} {
            display: inline-block;

            &:hover,
            &:focus-within {
                > ${ButtonLinkWithIcon} {
                    &:after {
                        opacity: 1;
                    }
                }
            }
        }
    `
);

const StyledLogoIcon = styled('div')((props) => {
    return css`
        width: 24px;
        height: ${props.theme.spacing['24px']};
        background-size: 24px 24px;
        margin-right: ${props.theme.spacing['8px']};
        background-image: ${smallZ};
    `;
});

const SignInLink = styled('li')(
    (props) => css`
        display: none;

        ${props.theme.mediaQueries.large} {
            display: block;
        }

        svg {
            fill: ${props.theme.colors['primary-brand']};
        }
    `
);

const SavedLink = styled('li')(
    (props) => css`
        display: none;

        ${props.theme.mediaQueries.large} {
            [data-is-logged-in] &[data-is-logged-in='true'] {
                display: block;
            }

            header:not([data-is-logged-in]) &[data-is-logged-in='false'] {
                display: block;
            }
        }
    `
);

const MyHomeLink = styled('li')(
    (props) => css`
        display: none;

        ${props.theme.mediaQueries.large} {
            display: block;
        }
    `
);

export {
    ProfileMenuWrapper,
    ProfileWrapper,
    IconWrapper,
    AccountMenuWrapper,
    SignedInLink,
    StyledLogoIcon,
    SignInLink,
    SavedLink,
    MyHomeLink
};
